import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FaArrowRight, FaClock, FaShieldAlt } from "react-icons/fa";
import { getSafeBlogImageUrl } from "./blogMedia";

export const formatBlogDate = (value, options = {}) => {
  const date = new Date(value);
  if (!value || Number.isNaN(date.getTime())) return "Recently published";
  return new Intl.DateTimeFormat("en-NG", {
    day: "numeric",
    month: "long",
    year: "numeric",
    ...options,
  }).format(date);
};

export const BlogImage = ({ post, eager = false, className = "" }) => {
  const [failed, setFailed] = useState(false);
  const source = getSafeBlogImageUrl(post?.cover_image_url);

  return (
    <div className={`blog-image ${className}`.trim()}>
      {source && !failed ? (
        <img
          src={source}
          alt={post?.cover_image_alt || ""}
          loading={eager ? "eager" : "lazy"}
          decoding="async"
          onError={() => setFailed(true)}
        />
      ) : (
        <div
          className="blog-image__fallback"
          role="img"
          aria-label="Thrive Insurance Insights"
        >
          <FaShieldAlt aria-hidden="true" />
          <span>Thrive Insurance Insights</span>
        </div>
      )}
    </div>
  );
};

const BlogCard = ({ post, compact = false }) => {
  if (!post) return null;

  return (
    <article className={`blog-card${compact ? " blog-card--compact" : ""}`}>
      <Link
        className="blog-card__media"
        to={`/blog/${post.slug}`}
        aria-label={`Read ${post.title}`}
      >
        <BlogImage post={post} />
      </Link>
      <div className="blog-card__body">
        <div className="blog-card__meta">
          <span>{post.category}</span>
          <time dateTime={post.published_at}>{formatBlogDate(post.published_at)}</time>
        </div>
        <h3>
          <Link to={`/blog/${post.slug}`}>{post.title}</Link>
        </h3>
        {!compact && <p>{post.excerpt}</p>}
        <div className="blog-card__footer">
          <span>
            <FaClock aria-hidden="true" />
            {post.read_time_minutes || 1} min read
          </span>
          <Link to={`/blog/${post.slug}`} aria-label={`Continue reading ${post.title}`}>
            Read insight <FaArrowRight aria-hidden="true" />
          </Link>
        </div>
      </div>
    </article>
  );
};

export default BlogCard;
